export default __webpack_public_path__ + "static/1860_1870-df1d13e745d24faee001a2e181c78eab.jpg";